import {Component, Injector, OnInit} from '@angular/core';
import {UserService} from '../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {PomodoroRepository} from '../Models/PomodoroRepository';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit {
  public pomodoroRepository: PomodoroRepository;
  constructor(private userService: UserService,
              private router: Router,
              public http: HttpClient,
              private activatedRoute: ActivatedRoute,
              private injector: Injector) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  public orderby: any;

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .subscribe(paramsN => {
          this.orderby = paramsN;
        }
      );
    this.userService.loginGoogleCallBack(this.orderby).subscribe(
      (data) => {
        localStorage.setItem('token', data);
        this.pomodoroRepository.userIsLoggedIn = true;
        setTimeout(() => {
          this.router.navigateByUrl('/').then();
        }, 1000);
      },
      (error) => {
        console.log(error);
      }
    );
  }

}
